import { Components, Theme } from '@mui/material/styles';
import { ChevronDownIcon } from '@/src/components/icon/stroke/ChevronDownIcon';

export const flowSelect: Components<Theme>['MuiSelect'] = {
  defaultProps: {
    IconComponent: ChevronDownIcon,
    MenuProps: {
      // turn off autofocus to prevent focus ring appearance
      // https://github.com/mui/material-ui/issues/23747
      disableAutoFocusItem: true,
    },
  },
  styleOverrides: {
    select: {
      // extra space for end icon
      '& ~ .MuiInputAdornment-positionEnd': {
        marginRight: '36px',
      },
    },
    icon: ({ ownerState }) => ({
      color: 'inherit',
      fontSize: '17px',
      flexShrink: '0',
      right: '12px',
      ...(['outlined', 'filled'].includes(ownerState.variant) && {
        right: '16px',
      }),
    }),
    standard: {
      '&&': {
        paddingRight: '36px',
      },
    },
    outlined: {
      '&&': {
        paddingRight: '36px',
      },
    },
    filled: {
      '&&': {
        paddingRight: '44px',
      },
    },
  },
};
